import { useQuery } from "react-query";
import { OrganizationVariablesFetchOptions } from "../models/types";
import {
  fetchOrganizationVariables,
  getOrganizationVariable,
  getOrganizationVariables,
} from "../services/VariablesService";
import { QueryKey } from "../state/QueryStore";

export const useOrganizationVariables = (params: OrganizationVariablesFetchOptions) => {
  return useQuery([QueryKey.OrganizationVariables, params], async () => {
    const { data } = await getOrganizationVariables(params);
    return data;
  });
};

export const useOrganizationVariable = (
  frameworkId: string,
  params: OrganizationVariablesFetchOptions
) => {
  return useQuery([QueryKey.OrganizationVariables, frameworkId], async () => {
    if (frameworkId === "") return undefined;
    const { data } = await getOrganizationVariable(frameworkId, params);
    return data;
  });
};

export const searchOrganizationVariables = async (searchText: string) => {
  const variables = await fetchOrganizationVariables({ search: searchText });
  return variables.results;
};
